<h2 *ngIf="athletes.length>0">{{'StageAwards' | transloco}}</h2>

<div class="pfp-ranking">
  <div *ngFor="let athlete of athletes" class="pfp-ranking__item">
    <a [href]="lang + 'athlete/'+athlete?.Athlete.Id.toString()">
      <div class="pfp-ranking__event">{{athlete.Details[0].NameShort}}</div>
      <div class="pfp-ranking__cat">{{athlete.catName}}</div>
      <img class="athlete__photo" [src]="'//extranet.worldarchery.sport/ProfilePictures/?Id=' + athlete.Athlete.Id" />
      <lib-athlete-name [fname]="athlete.Athlete.FName" [gname]="athlete.Athlete.GName" [wnameord]="athlete.Athlete.WNameOrd"
        [id]="athlete.Athlete.Id"></lib-athlete-name>
      <div class="pfp-ranking__points">{{ruleShowPercent(athlete.Points, athlete.Cat)|async}} <span>10s</span></div>
    </a>
  </div>
</div>
